module.exports = function() {
  return new Worker(__webpack_public_path__ + "svgExports.2279bd4f759e1e5f471e.js");
};